import { t, Trans } from '@lingui/macro'
import React from 'react'
import { Button, Tooltip } from '@tecsinapse/cortex-react'
import { GoQuestion } from 'react-icons/go'
import { useSuperAdminQueryHandler } from '../hooks/use-query-handler'

export const Migracao = () => {
  const { handleImportarGrupoUsuarios } = useSuperAdminQueryHandler()

  return (
    <div className={'flex flex-row items-center space-x-deca w-[50%]'}>
      <Button
        variants={{ className: 'flex-1' }}
        onClick={handleImportarGrupoUsuarios}
      >
        <Trans>Migrar Grupo Usuários</Trans>
      </Button>
      <Tooltip
        text={t`Migra os grupos de usuários padrões para o cliente atual.`}
      >
        <GoQuestion
          className={'text-primary-medium hover:cursor-pointer'}
          size={24}
        />
      </Tooltip>
    </div>
  )
}
